export const buildBreadcrumbLd = ({ baseUrl, items }) => {
  // items: [{ label: 'Home', href: '/' }, { label: 'Contact', href: '/contact' }]
  const itemListElement = items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.label,
    item: `${baseUrl}${it.href}`,
  }));

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  };
};



// Blog post page

// buildBreadcrumbLd({
//   baseUrl: FULL_BUSINESS_URL,
//   items: [
//     { label: 'Home', href: HOME_PAGE_URL },
//     { label: 'Blog', href: '/blog' },
//     { label: post.title, href: `/blog/${post.slug}` },
//   ],
// })


// Project detail

// buildBreadcrumbLd({
//   baseUrl: FULL_BUSINESS_URL,
//   items: [
//     { label: 'Home', href: HOME_PAGE_URL },
//     { label: 'Projects', href: '/projects' },
//     { label: project.title, href: `/projects/${project.slug}` },
//   ],
// })